<template>
  <div v-if="page">
    <h2>{{ $t("resort.title") }}</h2>
    <div v-if="page.doc" class="row mb-3">
      <page-title :subheading="page.doc.content"></page-title>
    </div>
    <exclusives-table
      :allUsers="false"
      :packages="page.era"
      :tableTitle="$t('resort.my-accesses')"
      :header="headers"
    ></exclusives-table>
  </div>
</template>

<script>
import ExclusivesTable from "../components/Packages/ExclusivesTable";
import gql from "graphql-tag";
export default {
  name: "MyTravelsPage",
  components: {
    ExclusivesTable,
  },
  data() {
    return {
      headers: [
        {
          value: "ID",
          text: this.$i18n.t("resort.accessestable-id"),
          sortable: false,
        },
        {
          value: "startDate",
          text: this.$i18n.t("resort.accessestable-start-date"),
          sortable: false,
        },
      ],
    };
  },
  apollo: {
    page: {
      query: gql`
        query {
          era {
            id
          }
        }
      `,
      variables: {},
      update: (data) => data,
      result({ data }) {
        console.log(data);
      },
    },
  },
};
</script>

<style scoped></style>